import React, { useEffect, useState } from 'react';
import { profileAvatar } from "../component/ImageList";
import baseURL from '../component/baseURL';
import { useNavigate } from 'react-router-dom';
import showNotification from '../component/Notification';

export default function MyFeedProposed({ hideMobileHeader = false }) {
    const navigate = useNavigate();
    const [myFeedProposed, setMyFeedProposed] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [deleteModalRequestId, setDeleteModalRequestId] = useState(null);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const userID = localStorage.getItem('user_id');
        fetchMyFeedProposed(userID);
    }, []);


    function fetchMyFeedProposed(userID) {
        setLoading(true);
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")

        console.log(formdata);

        fetch(baseURL.URL + '/portfolio_feed/my_feed_proposed', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server && responseJson.server.code === 200) {
                    const list = responseJson.response?.member_feed_active ?? [];
                    setMyFeedProposed(Array.isArray(list) ? list : []);
                    setLoading(false);
                } else {
                    setMyFeedProposed([]);
                    if (responseJson.server?.message) console.error(responseJson.server.message);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }

    function deleteFeed(requestID) {
        const userID = localStorage.getItem('user_id');
        if (!userID || !requestID) return;
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("request_id", requestID)
        fetch(baseURL.URL + '/portfolio_feed/delete_feed', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.code === 200) {
                    fetchMyFeedProposed(userID);
                    showNotification(responseJson.server.message, 'success', 'top-right')
                }
                else {
                    showNotification(responseJson.server.message, 'danger', 'top-right')
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    // Keep the name user asked for
    function DeleteFeed(requestID) {
        deleteFeed(requestID);
    }

    function handleDeleteClick(e, requestId) {
        e?.stopPropagation?.();
        if (requestId) setDeleteModalRequestId(requestId);
    }

    function handleDeleteCancel() {
        setDeleteModalRequestId(null);
    }

    function handleDeleteConfirm() {
        if (deleteModalRequestId) {
            DeleteFeed(deleteModalRequestId);
        }
        setDeleteModalRequestId(null);
    }

    const handleMobileBack = () => {
        navigate('/feed', { replace: true });
    };


    const mobileHeader = isMobile && !hideMobileHeader ? (
        <div className="mobile-page-header">
            <button type="button" className="mobile-back-btn" onClick={handleMobileBack} aria-label="Back">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <h2 className="mobile-page-title">My Feed Proposed</h2>
        </div>
    ) : null;


    if (loading) {
        return (
            <>
                {mobileHeader}
                <div className={`content-right ${isMobile ? 'feed-proposed-page-mobile' : ''} page-loader-wrapper`}>
                    <div className="react-js-loader">
                        <div className="react-js-loader-spinner"></div>
                        <p className="react-js-loader-text">Loading...</p>
                    </div>
                </div>
            </>
        );
    }


    return (
        <>
            {mobileHeader}
            <div className={`content-right ${isMobile ? 'feed-proposed-page-mobile' : ''}`}>
            {/* Search and Filter Section */}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                    />
                </div>
            </div>

            <div className="feed-proposed-section">
                <div className="feed-proposed-grid">
                    {myFeedProposed.map((item, index) => {
                        const user = item.user_details || {};
                        const ud = item.user_details ?? {};
                        const name = user.user_name || [user.fname, user.lname].filter(Boolean).join(' ') || '—';
                        const stateVal = (user.state_name || user.state || '').trim();
                        const locationParts = [user.city_name, user.country_name].filter(Boolean);
                        const location = locationParts.length ? locationParts.join(' - ') : '—';
                        const avatar = user.user_image_thumb || user.user_image || profileAvatar;
                        const dateDisplay = item.added_date ? String(item.added_date).replace(/\//g, '-') : '—';
                        const companyImage = user.company_image_thumb || user.company_image || 'https://placehold.co/48x48';
                        return (
                            <div key={item.request_id || index} className="feed-proposed-card">
                                <div className="feed-card-top"
                                    onClick={() => {
                                        navigate('/member-profile', {
                                            state: {
                                                memberID: ud.user_id,
                                                member: ud,
                                                from: '/feed/received'
                                            }
                                        });
                                    }}>
                                    <div className="feed-card-profile">
                                        <img src={avatar} alt={name} />
                                    </div>
                                    <div className="feed-card-info">
                                        <h3 className="feed-card-name">{name}</h3>
                                        <p className="feed-card-location">{location}</p>
                                    </div>
                                    <div className="feed-card-placeholder">
                                        <img src={companyImage} alt={name} />
                                    </div>
                                </div>
                                <div className="feed-card-bottom">
                                    <div
                                        className="feed-status"
                                        onClick={() => {
                                            navigate('/feed/connection-feed-settings', {
                                                state: {
                                                    user_details: ud,
                                                    member_id: item.receiver_id,
                                                    memberID: item.receiver_id,
                                                    member: ud,
                                                    returnTo: {
                                                        path: '/feed/my-feed-proposed',
                                                        state: {},
                                                    },
                                                },
                                            });
                                        }}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                navigate('/feed/connection-feed-settings', {
                                                    state: {
                                                        user_details: ud,
                                                        member_id: item.receiver_id,
                                                        memberID: item.receiver_id,
                                                        member: ud,
                                                        returnTo: {
                                                            path: '/feed/my-feed-proposed',
                                                            state: {},
                                                        },
                                                    },
                                                });
                                            }
                                        }}
                                    >
                                        <div className="feed-download-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                <path d="M21.3887 13.2428H20.6456V3.61089C20.6456 2.38867 19.6456 1.38867 18.4234 1.38867H6.44423C5.85395 1.38867 5.29145 1.61784 4.87478 2.04145L2.04145 4.87478C1.62478 5.29145 1.38867 5.85395 1.38867 6.44423V21.3887C1.38867 21.972 1.62478 22.5484 2.04145 22.9581C2.45812 23.3748 3.02062 23.6109 3.61089 23.6109H21.3887C22.6109 23.6109 23.6109 22.6109 23.6109 21.3887V15.4651C23.6109 14.2428 22.6109 13.2428 21.3887 13.2428ZM3.09006 21.9095C2.95117 21.7706 2.87478 21.5831 2.87478 21.3887V6.44423C2.87478 6.24978 2.95117 6.05534 3.09006 5.92339L5.92339 3.09006C6.06228 2.95117 6.24978 2.87478 6.44423 2.87478H18.4234C18.8331 2.87478 19.1665 3.20812 19.1665 3.61784V13.2498H15.4651C14.2428 13.2498 13.2428 14.2498 13.2428 15.472V22.1387H3.61089C3.41645 22.1387 3.22201 22.0623 3.09006 21.9234V21.9095ZM22.1317 21.3887C22.1317 21.7984 21.7984 22.1317 21.3887 22.1317H14.722V15.4651C14.722 15.0553 15.0553 14.722 15.4651 14.722H21.3887C21.7984 14.722 22.1317 15.0553 22.1317 15.4651V21.3887Z" fill="#A17F00" />
                                                <path d="M19.3818 16.979L18.0623 18.3123L17.4581 17.7359C17.1665 17.4512 16.6943 17.4651 16.4095 17.7567C16.1248 18.0553 16.1387 18.5206 16.4304 18.8053L17.5623 19.8887C17.7082 20.0276 17.8887 20.097 18.0762 20.097C18.2637 20.097 18.4582 20.0206 18.604 19.8748L20.4373 18.0206C20.722 17.729 20.722 17.2637 20.4373 16.972C20.1457 16.6803 19.6804 16.6873 19.3887 16.972L19.3818 16.979Z" fill="#A17F00" />
                                                <path d="M5.83339 8.79861H16.2014C16.6112 8.79861 16.9445 8.46528 16.9445 8.05556C16.9445 7.64583 16.6112 7.3125 16.2014 7.3125H5.83339C5.42367 7.3125 5.09033 7.64583 5.09033 8.05556C5.09033 8.46528 5.42367 8.79861 5.83339 8.79861Z" fill="#A17F00" />
                                                <path d="M5.83339 12.4998H10.2778C10.6876 12.4998 11.0209 12.1665 11.0209 11.7567C11.0209 11.347 10.6876 11.0137 10.2778 11.0137H5.83339C5.42367 11.0137 5.09033 11.347 5.09033 11.7567C5.09033 12.1665 5.42367 12.4998 5.83339 12.4998Z" fill="#A17F00" />
                                                <path d="M10.2778 14.7222H5.83339C5.42367 14.7222 5.09033 15.0555 5.09033 15.4652C5.09033 15.8749 5.42367 16.2083 5.83339 16.2083H10.2778C10.6876 16.2083 11.0209 15.8749 11.0209 15.4652C11.0209 15.0555 10.6876 14.7222 10.2778 14.7222Z" fill="#A17F00" />
                                            </svg>
                                        </div>
                                        <div className="feed-status-text">
                                            <span className="feed-status-label">Feed Proposed</span>
                                            <span className="feed-status-date">{dateDisplay}</span>
                                        </div>
                                    </div>
                                    <div className="feed-card-actions">

                                        <button
                                            type="button"
                                            className="feed-action-btn feed-delete-btn"
                                            aria-label="Delete"
                                            onClick={(e) => handleDeleteClick(e, item.request_id)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M10.5325 2.0835C9.76543 2.0835 9.1436 2.70532 9.1436 3.47238C9.1436 3.85591 8.83269 4.16683 8.44915 4.16683H8.33342H5.20841C4.63312 4.16683 4.16675 4.6332 4.16675 5.2085C4.16675 5.78379 4.63312 6.25016 5.20841 6.25016H8.33342H8.44915H16.5494H16.551H16.6667H19.7917C20.3671 6.25016 20.8334 5.78379 20.8334 5.2085C20.8334 4.6332 20.3671 4.16683 19.7917 4.16683H16.5502C16.1671 4.16637 15.8565 3.85564 15.8565 3.47238C15.8565 2.70532 15.2348 2.0835 14.4677 2.0835H10.5325Z" fill="#ED6D48" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.25016 8.3335C5.95886 8.3335 5.68087 8.45548 5.48362 8.66984C5.28638 8.8842 5.1879 9.17137 5.2121 9.46167L6.01497 19.0962C6.19493 21.2558 8.00021 22.9168 10.1672 22.9168H14.8331C17.0002 22.9168 18.8054 21.2558 18.9854 19.0962L19.7882 9.46167C19.8125 9.17137 19.7139 8.8842 19.5167 8.66984C19.3194 8.45548 19.0415 8.3335 18.7502 8.3335H6.25016Z" fill="#ED6D48" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Delete confirmation modal (same style as logout modal) */}
            {deleteModalRequestId && (
                <>
                    <div className="modal-overlay" onClick={handleDeleteCancel} aria-hidden="true" />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="proposed-delete-modal-title">
                        <h3 id="proposed-delete-modal-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            Delete
                        </h3>
                        <p style={{ margin: '0 0 25px 0', fontSize: '16px', color: '#fff', lineHeight: '1.5' }}>
                            Are you sure you want to delete?
                        </p>
                        <div className="btn-sec">
                            <button type="button" className="cancel-btn custom-btn" onClick={handleDeleteCancel}>
                                No
                            </button>
                            <button type="button" className="save-btn custom-btn" onClick={handleDeleteConfirm}>
                                Yes
                            </button>
                        </div>
                    </div>
                </>
            )}
            </div>
        </>
    )
}